module.exports = __webpack_public_path__ + "assets/img/cards.41be5a6a.svg";